import { max, scaleLinear, scaleTime, timeMonth } from "d3";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import * as d3 from 'd3';
import { DottedLinesRenderer } from "../components/renderers/dottedLinesRenderer";
import { YAxis } from "../components/axis/yAxis";
import { TimeAxis } from "../components/axis/timeAxis";
import { DataPoint, Line } from "../types";
import { Legends } from "../components/draggableLegends";
import { pointer } from "d3";
import { DraggableWrapper } from "../components/wrappers/DraggableWrapper";


export const MARGINS = { top: 20, bottom: 50, left: 50, right: 50 }

const getContainerWidth = (): number => {
    return parseInt(d3.select("#chart-container").style("width"))
}

export function MultipleLinesPlot({ data, startDate, endDate }: { data?: Line[], startDate: Date, endDate: Date }) {

    useEffect(() => {
        console.log("Data: ", data);
        
    }, [data])

    const svgHeight = 700;
    const [width, setWidth] = useState(1400);
    const svgRef = useRef<any>(null);

    const [filteredLabels, setFilteredLabels] = useState<string[]>([]);

    const [filteredData, setFilteredData] = useState<Line[] | undefined>(data);
    const [mouseCoords, setMouseCoords] = useState({ x: 0, y: 0 });

    const onMouseMove = (e: any) => {
        setMouseCoords({ ...{ x: pointer(e)[0], y: pointer(e)[1] } });
    }

    useEffect(() => {
        setWidth(getContainerWidth());
    }, []);


    const yMax: number = max(filteredData?.flatMap((l: Line) => l?.dataPoints?.map((d: DataPoint) => d.y * 1.5)) || []) || 0;

    const tScale = scaleTime()
        .domain([startDate.getTime(), endDate.getTime()])
        .range([MARGINS.left, width - MARGINS.right])
        .nice(timeMonth)

    const yScale =
        scaleLinear()
            .domain([yMax, 0])
            .range([MARGINS.top, svgHeight - MARGINS.bottom]);

    const xAxisTickFormatter = (tickVal: any) => {
        const date = new Date(tickVal);
        return `${date.getMonth() + 1}/${date.getFullYear()}`
    }


    useEffect(() => {
        setFilteredData(data?.filter((d: Line, idx: number) => !filteredLabels.includes(d?.metadata?.label)));
    }, [filteredLabels, data])


    return (
        <DraggableWrapper>
            <svg id={"chart-container"} ref={svgRef} width={width} height={svgHeight} onMouseMove={onMouseMove}>
                <YAxis margins={MARGINS} yScale={yScale} chartDimensions={{ height: svgHeight, width: width }} tickFormattingFunction={(tickVal: number) => tickVal.toString()} />
                <TimeAxis margins={MARGINS} xScale={tScale} yPosition={svgHeight - MARGINS.bottom} tickFormattingFunction={xAxisTickFormatter} />
                <DottedLinesRenderer xScale={tScale} yScale={yScale} data={filteredData} />
                <Legends mouseCoords={mouseCoords} filteredLabels={filteredLabels} setFilteredLabels={setFilteredLabels} plots={data?.map((d: Line) => d?.metadata) || []} chartDimensions={{ height: svgHeight, width: width }} />
            </svg>
        </DraggableWrapper>
    )


}